import { isUndefined } from "./is-undefined";

const isNull = (value: unknown): value is null => {
    return value === null;
};
const isNotNull = <T>(value: T): value is Exclude<T, null> => {
    return !isNull(value);
};
const isNullOrUndefined = (value: unknown): value is null | undefined => {
    return isNull(value) || isUndefined(value);
};
const isNotNullOrUndefined = <T>(
    value: T,
): value is Exclude<T, null | undefined> => {
    return !isNullOrUndefined(value);
};
const isNaNOrNullOrUndefined = (value: unknown): value is null | undefined => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return isNullOrUndefined(value) || isNaN(value as any);
};
const isNotNaNOrNullOrUndefined = <T>(
    value: T,
): value is Exclude<T, null | undefined> => {
    return !isNaNOrNullOrUndefined(value);
};

// Modified stack overflow thingy
const isStringNumeric = (input: string): boolean => {
    if (typeof input !== "string") return false;
    return !isNaN(parseFloat(input)) && isFinite(parseFloat(input));
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isNumber = (value: any): value is number => {
    return !isNaNOrNullOrUndefined(value) && typeof value === "number";
};
const isNotNumber = <T>(value: T): value is Exclude<T, number> => {
    return !isNumber(value);
};

export {
    isNaNOrNullOrUndefined,
    isNotNaNOrNullOrUndefined,
    isNotNull,
    isNotNullOrUndefined,
    isNotNumber,
    isNull,
    isNullOrUndefined,
    isNumber,
    isStringNumeric,
};
